module.exports = __webpack_public_path__ + "static/media/yardnapha-avalible.069bbc2d.png";